export enum ProviderStatus {
  new = 'new',
  verified = 'verified',
  reviewed = 'reviewed',
  dataCollection = 'data_collection',
  mechanicalTurkReview = 'mechanical_turk_review',
  providerNotValid = 'provider_not_valid',
  notAReferralSpecialty = 'not_a_referral_specialty',
}
